import OwnerPlans from "@/components/OwnerPlans";

export default function OwnerPlansPage() {
  return <OwnerPlans />;
}
